import React, { useRef, useState } from 'react';
import { supabase } from '../lib/supabase';

export default function PhotoCapture({ questionCode, submissionId, tenantId, value, onChange }) {
  const inputRef              = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [preview, setPreview]     = useState(null);
  const [error, setError]         = useState(null);

  async function handleFile(e) {
    const file = e.target.files[0];
    if (!file) return;
    setUploading(true);
    setError(null);
    try {
      const reader = new FileReader();
      reader.onload = ev => setPreview(ev.target.result);
      reader.readAsDataURL(file);
      const ext = file.name.split('.').pop();
      const key = `assessments/${tenantId}/${submissionId}/${questionCode}_${Date.now()}.${ext}`;
      const { error: uploadError } = await supabase.storage
        .from('submission-documents')
        .upload(key, file, { contentType: file.type, upsert: false });
      if (uploadError) throw uploadError;
      onChange(file.name, key);
    } catch (err) {
      console.error('Upload error:', err);
      setError('Upload failed. Please try again.');
    } finally {
      setUploading(false);
    }
  }

  return (
    <div style={{ width:'100%', boxSizing:'border-box' }}>
      {preview ? (
        <div style={{ position:'relative' }}>
          <img
            src={preview}
            alt="captured"
            style={{ width:'100%', borderRadius:8, border:'2px solid #4ade80', display:'block' }}
          />
          <button
            onClick={() => { setPreview(null); onChange(null, null); }}
            style={{
              position:'absolute', top:8, right:8,
              background:'rgba(0,0,0,0.7)', border:'none',
              color:'#fff', borderRadius:4, padding:'4px 10px',
              fontSize:12, cursor:'pointer',
            }}
          >
            Retake
          </button>
        </div>
      ) : (
        <div
          onClick={() => inputRef.current?.click()}
          style={{
            width:'100%', minHeight:160, borderRadius:8,
            border:'2px dashed #333', background:'#141414',
            display:'flex', flexDirection:'column',
            alignItems:'center', justifyContent:'center',
            cursor:'pointer', gap:12, padding:24,
            boxSizing:'border-box',
          }}
        >
          <div style={{ fontSize:36 }}>📷</div>
          <div style={{ fontSize:14, color:'#666', textAlign:'center' }}>
            {uploading ? 'Uploading...' : 'Tap to take photo or choose from library'}
          </div>
          {error && <div style={{ fontSize:12, color:'#f87171' }}>{error}</div>}
        </div>
      )}
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        onChange={handleFile}
        style={{ display:'none' }}
      />
    </div>
  );
}
